import React from 'react';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';
import { Row } from '../../Resources';
import ActivitiesRegistrationHeader from '../../ActivitiesRegistrationHeader';

import { convertToReal } from 'helpers/converters';

export default function SchedulingRemotion({ activityData, lastRegister }) {
  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader activityData={activityData} />
      </Grid>
      <Grid container style={{ marginTop: 10 }}>
        <Grid xs={12}>
          <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
            {Object.keys(lastRegister).includes('clientName') && (
              <Row>
                <Typography color='primary'>
                  <b>Cliente</b>
                </Typography>
                <Typography color='textSecondary'>
                  {lastRegister?.clientName}
                </Typography>
              </Row>
            )}
            {Object.keys(lastRegister).includes('endDateTime') && (
              <Row>
                <Typography color='primary'>
                  <b>Data início</b>
                </Typography>
                <Typography color='textSecondary'>
                  {moment(lastRegister?.startDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')}
                </Typography>
              </Row>
            )}
            {Object.keys(lastRegister).includes('endDateTime') && (
              <Row>
                <Typography color='primary'>
                  <b>Data fim</b>
                </Typography>
                <Typography color='textSecondary'>
                  {moment(lastRegister?.endDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')}
                </Typography>
              </Row>
            )}
            <Row>
              <Typography color='primary'>
                <b>Serviços</b>
              </Typography>
              <div>
                {lastRegister?.services?.length > 0 && lastRegister?.services?.map(service => {
                  return(
                    <Typography color='textSecondary'>
                      {service?.serviceName} ({service?.quantity}) - {convertToReal(service?.amount)}
                    </Typography>
                  );
                })}
              </div>
            </Row>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}